import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Box } from "@chakra-ui/react";
import { CustomCursor, Header, Footer } from "./components";
import { useIsMobile } from "./utils/useIsMobile";
import Home from "./pages/Home";
const Portfolio = React.lazy(() => import("./pages/Portfolio"));
const About = React.lazy(() => import("./pages/About"));
const Resume = React.lazy(() => import("./pages/Resume"));

const redirectPath = window.location.search.slice(1);
if (redirectPath) {
  window.history.replaceState(null, "", "/" + redirectPath);
}

const AppWrapper = () => {
  const location = useLocation();
  const isMobile = useIsMobile();

  return (
    <Box
      px={{ base: 6, md: 12, lg: 75 }}
      minHeight="100dvh"
      display="flex"
      flexDirection="column"
    >
      {!isMobile && <CustomCursor />}
      <Header />
      <Box flex="1" display="flex" flexDirection="column">
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </Suspense>
      </Box>

      {(location.pathname !== "/about" || isMobile) && <Footer />}
    </Box>
  );
};

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
